"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalExcluir = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const Button_1 = __importDefault(require("../../Button"));
const CardContainer_1 = require("../../CardContainer");
const styles_1 = require("./styles");
const ModalExcluir = ({ open, onClose, item, handleExcluir, }) => {
    return (react_1.default.createElement(core_1.Dialog, { open: open, onClose: onClose },
        react_1.default.createElement(CardContainer_1.CardContainer, null,
            react_1.default.createElement(core_1.Typography, null, "Tem certeza de que deseja excluir esse item ?"),
            react_1.default.createElement(styles_1.Content, null,
                react_1.default.createElement(icons_1.DeleteForeverOutlined, { style: { width: '5rem', height: '5rem' } }),
                react_1.default.createElement(core_1.Typography, { variant: "h6" }, item)),
            react_1.default.createElement(core_1.Grid, { container: true, justify: "flex-end" },
                react_1.default.createElement(Button_1.default, { type: "button", onClick: onClose, rounded: true }, "Cancelar"),
                react_1.default.createElement(Button_1.default, { color: "secondary", type: "button", rounded: true, onClick: handleExcluir }, "Excluir")))));
};
exports.ModalExcluir = ModalExcluir;
//# sourceMappingURL=index.js.map